var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConduiitWtIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 14,
    viewBox: "0 0 28 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5375 0.614014C17.7996 0.614014 15.8161 2.71159 13.9987 5.09295C12.1813 2.71159 10.1992 0.614014 7.4626 0.614014C3.85785 0.614014 0.92516 3.61648 0.92516 7.30699C0.923058 8.18528 1.0905 9.05534 1.41788 9.86717C1.74525 10.679 2.2261 11.4166 2.83278 12.0376C3.43707 12.6614 4.15635 13.156 4.94888 13.4929C5.74141 13.8298 6.5914 14.0021 7.44952 14H7.46521C10.1966 13.9933 12.1787 11.8957 13.9974 9.51433C15.8161 11.8997 17.7996 14 20.5375 14C24.1422 14 27.0749 10.9975 27.0749 7.30699C27.0749 3.61648 24.1422 0.614014 20.5375 0.614014ZM7.45998 11.3228H7.44952C6.40484 11.3228 5.42292 10.9051 4.68549 10.1475C4.13896 9.58471 3.7673 8.86894 3.61732 8.09034C3.46735 7.31173 3.54576 6.5051 3.84269 5.77203C4.13961 5.03895 4.64178 4.41222 5.28593 3.97077C5.93009 3.52931 6.68744 3.29286 7.4626 3.2912C9.20156 3.2912 10.8098 5.2161 12.3604 7.30431C10.8072 9.39118 9.19894 11.3188 7.45998 11.3228ZM20.5375 11.3228C18.7985 11.3228 17.189 9.3952 15.6357 7.30431C17.1877 5.2161 18.7959 3.2912 20.5375 3.2912C22.7001 3.2912 24.4599 5.09295 24.4599 7.30699C24.4599 9.52102 22.7001 11.3228 20.5375 11.3228Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConduiitWtIcon);
export default __webpack_public_path__ + "static/media/conduiitWTIcon.a0a770d7de4e8e63813455d52f73e5ef.svg";
export { ForwardRef as ReactComponent };